import React from 'react';

function About() {
  return (
    <section id="about">
      <div className="container about">
        <div className="text">
          <h2>Wenn Technik nicht gewartet ist. Wenn niemand die Verantwortung übernimmt.</h2>
          <p>
            Wenn der Reinigungsdienst zum Dauerthema wird. Wenn sich niemand kümmert. Dann ist das nicht einfach „schlechtes FM“ – es ist ein Systemproblem.
          </p>
          <p>
            Viele Unternehmen erleben genau das: steigende Kosten, ständiger Ärger, wechselnde Dienstleister – aber keine Besserung.
          </p>

          <p>

            <h3>FH Consulting setzt früher an.</h3>
            Wir schaffen die Rahmenbedingungen, in denen Facility Management wirklich wirkt: durch klare Prozesse, stabile Rollen, digitale Unterstützung – und eine Haltung, die auf Vertrauen statt Kontrolle baut.
          </p>
        </div>
        <div className="image">
          <img 
            src={require('../images/about-img.png')} 
            alt="Abstrakte Grafik, die Vernetzung symbolisiert" 
          />
        </div>
      </div>
      
      {/* Persönliche Vorstellung */}
      <div className="container about founder-section">
        <div className="image">
          <img 
            src={require('../images/Huber-Florian-Cropped.jpg')} 
            alt="Florian Huber, Gründer von FH Consulting" 
          />
        </div>
        <div className="text">
          <h2>Ihr&nbsp;Ansprechpartner</h2>
          <h3>Florian Huber</h3>
          <p>
            Als Gründer von FH Consulting bringe ich über 10 Jahre Erfahrung im Facility Management mit – von der operativen Umsetzung bis zur strategischen Beratung. Mein Fokus liegt darauf, komplexe Strukturen zu vereinfachen und nachhaltige Lösungen zu entwickeln, die wirklich funktionieren.
          </p>
          <p>
            Meine Überzeugung: Erfolgreiche FM-Projekte entstehen durch ehrliche Kommunikation, strukturiertes Vorgehen und den Mut, auch unbequeme Wahrheiten anzusprechen. Dabei arbeite ich partnerschaftlich mit meinen Kunden – denn die besten Lösungen entstehen gemeinsam.
          </p>
          <p>
            <strong>Schwerpunkte:</strong> Strategische FM-Beratung, Prozessoptimierung, Digitalisierung, Change Management
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;
